"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const NotificationsTab_1 = require("../pages/NotificationsTab");
const index_1 = require("./index");
function transformNotifications(notifications) {
    if (!notifications || !Array.isArray(notifications)) {
        return {
            extraData: {},
            nextAction: NotificationsTab_1.SelectAction.Select,
        };
    }
    const transformedNotifications = notifications.reduce((acc, { identifier, type, message, user, group }) => {
        const important = (0, index_1.isNotificationImportant)(type, message, user, group);
        const notification = {
            identifier,
            important,
            selected: false,
        };
        acc.extraData[identifier] = notification;
        return acc;
    }, {
        extraData: {},
        nextAction: NotificationsTab_1.SelectAction.Select,
    });
    return transformedNotifications;
}
exports.default = transformNotifications;
